/* eslint-disable no-undef */

import React, {PureComponent} from 'react'
import {withStyles} from "@material-ui/core/styles/index";
import QuestionPageStepper from "./QuestionPageStepper";
import { Grid } from '@material-ui/core';

const styles = theme => ({
    root: {
        background: theme.headerBackground ? theme.headerBackground : '#ffffff',
        boxShadow: theme.headerBoxShadow ? theme.headerBoxShadow : '0 1px 10px rgba(0, 0, 0, 0.15)',
        marginBottom: theme.spacing(4),
        [theme.breakpoints.down(600)]: {
            marginBottom: theme.spacing(2),
        },
    },
    container: {
        maxWidth: 960,
        margin: 'auto',
        padding: theme.spacing(1.25) + 'px ' + theme.spacing(3) + 'px ' + theme.spacing(2) + 'px ' + theme.spacing(2.5) + 'px',
    },
    logo: {
        width: theme.logoWidth,
        height: 30,
        float: 'left',
        background: 'url(' + theme.logo + ')',
        backgroundSize: 'contain',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        marginTop: 3,
    },
    primaryThemeColorCircle: {
        width: 15,
        height: 15,
        background: theme.palette.primaryColor,
        float: 'right',
        margin: '12px 0 0 12px',
        borderRadius: 12,
    },
    secondaryThemeColorCircle: {
        width: 15,
        height: 15,
        background: theme.palette.secondaryColor,
        float: 'right',
        margin: '12px 0 0 12px',
        borderRadius: 12,
    },
});

class PageHeader extends PureComponent {
    render() {
        const {classes} = this.props;
        return (
            <div className={classes.root}>
                <Grid container className={classes.container}>
                    <Grid item xs={12}>
                        <div className={classes.logo} style={{paddingRight: 30}}>
                        </div>
                        <div className={classes.secondaryThemeColorCircle}></div>
                        <div className={classes.primaryThemeColorCircle}></div>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withStyles(styles)(PageHeader);
